import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ScheduleOption } from 'src/app/pages/schedule-register/models/schedule-option-interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { scheduleOptionSelectors } from '../state/schedule-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: ScheduleSelectComponent,
        },
    ],
    selector: 'ndt-schedule-select',
    templateUrl: './schedule-select.component.html',
    standalone: false
})
export class ScheduleSelectComponent extends LcsSingleSelectBase<ScheduleOption> implements OnInit {
   schedules: Observable<ScheduleOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.schedules = this.store.pipe(select(scheduleOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: ScheduleOption | null): string | null {
      return item ? item.name : null;
   }

   trackBy(item: ScheduleOption | null) {
      return item ? item.scheduleId : null;
   }
}
